import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { PosService } from '../../_services/pos.service';

@Component({
    selector: 'app-store-pos-setup',
    templateUrl: './store-pos-setup.component.html',
    styleUrls: ['./store-pos-setup.component.css'],
})
export class StorePosSetupComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    cookieStore: any;
    posConfigForm: FormGroup;

    role: any;
    routeRole: any;

    posProviders: any[] = [];
    hasPosConfig = false;
    selectedProvider = { label: 'Select a provider', value: null };
    currentPosProvider: any;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService,
        public _posService: PosService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];

        this.posConfigForm = fb.group({
            eposStoreId: new FormControl(),
            posProviderId: new FormControl(),
            premierToken: new FormControl(),
            premierUrl: new FormControl(),
        });
    }

    ngOnInit() {
        this.getStore(this.storeId);
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                // console.log(data);
                this.selectedStore = data;
                this.getPosProviders();
                if (this.selectedStore.posConfig !== null) {
                    this.hasPosConfig = true;
                    this.populatePosConfig();
                    this.currentPosProvider = this.selectedStore.posConfig.posProvider;
                    // console.log('POS CONFIG - ', this.selectedStore.posConfig);
                    this.selectedProvider = {
                        label: this.selectedStore.posConfig.posProvider.description,
                        value: this.selectedStore.posConfig.posProvider,
                    };
                    // console.log('Selected Provider - ', this.selectedProvider);
                } else {
                    this.hasPosConfig = false;
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    public populatePosConfig() {
        this.posConfigForm.patchValue({
            eposStoreId: this.selectedStore.posConfig.eposStoreId,
            premierToken: this.selectedStore.posConfig.premierToken,
            premierUrl: this.selectedStore.posConfig.premierUrl,
        });
    }

    // Get a list of all Pos Providers, platform wide
    public getPosProviders() {
        this._posService.getAllPosProviders().subscribe((data: any) => {
            // console.log(data);
            this.posProviders.push({ label: 'Select a provider', value: null });
            data.forEach((element) => {
                // const item = {
                //     id: element.id,
                //     value: element.description
                // };

                const obj = {
                    label: element.description,
                    value: element,
                };
                this.posProviders.push(obj);
            });
        });
    }

    public selectedProviderChanged(event) {
        // console.log('Change provider event ', event);
        // if (event === 'EPOS Pos Provider') {
        //     this.selectedProvider = this.posProviders[1];
        // } else if (event === 'Premier Pos Provider') {
        //     this.selectedProvider = this.posProviders[2];
        // } else {
        //     this.selectedProvider = this.posProviders[0];
        // }

        this.selectedProvider = event;
    }

    // Create Config
    public createPosConfig() {
        const values = this.posConfigForm.value;
        const body = {
            eposStoreId: '',
            posProviderId: this.selectedProvider.value.id,
            premierToken: '',
            premierUrl: '',
            storeId: this.storeId,
        };
        if (this.selectedProvider.value.value === 'EPOS') {
            body.eposStoreId = values.eposStoreId;
        } else {
            body.premierToken = values.premierToken;
            body.premierUrl = values.premierUrl;
        }
        this._posService.createPosConfig(body).subscribe((data: any) => {
            // console.log(data);

            this.notificationService.notify(
                'success',
                'POS Setup Saved',
                'POS setup has successfully saved',
                'top',
                'right'
            );
        });
    }

    // Edit Config
}



// WEBPACK FOOTER //
// ./src/app/indi-store/pos-setup/store-pos-setup.component.ts